import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';
import classNames from 'classnames';
import './StatCard.css';

export function StatCard({ 
  label,
  value,
  icon,
  trend,
  color = 'primary',
  className = '',
  ...props
}) {
  const cardClasses = classNames(
    'agrisense-stat-card',
    className
  );

  const iconClasses = classNames(
    'agrisense-stat-card__icon',
    `agrisense-stat-card__icon--${color}`
  );

  return (
    <div className={cardClasses} {...props}>
      {icon && (
        <div className={iconClasses}>
          {icon}
        </div>
      )}
      <div className="agrisense-stat-card__label">{label}</div>
      <div className="agrisense-stat-card__value">{value}</div>
      {trend && (
        <div className={`agrisense-stat-card__trend agrisense-stat-card__trend--${trend.direction}`}>
          {trend.direction === 'up' ? <ArrowUp size={16} /> : <ArrowDown size={16} />}
          <span>{Math.abs(trend.value)}%</span>
        </div>
      )}
    </div>
  );
}